import axios from 'axios'

import { isServer } from '../utils/isServer'

import {
  handleAxiosResponse,
  handleAxiosErrorResponse
} from '../utils/handleAxiosResponse'

import { getTime } from '../utils/timeUtils'

const INNER_URL_HOSTNAME_MAP = {
  '/client/api': 'http://internal-2c-prod-client-api-ialb-627108888.us-west-1.elb.amazonaws.com',
  '/content/api': 'http://internal-2c-prod-comment-api-ialb-1343603474.us-west-1.elb.amazonaws.com',
  '/marketing/api': 'http://internal-2c-prod-mar-web-ialb-1303191947.us-west-1.elb.amazonaws.com',
}

class HttpClient {
  constructor(options = {}) {
    // 取消限制每台主机只有5个套接字
    options.agent = false;

    this._options =  options
    this.$client = this.createHttpClient(options)
  }

  createHttpClient(options) {
    let timeout = parseInt(options.timeout, 10)
    if (isNaN(timeout)) {
      timeout = 5000
    }

    const $http = axios.create({
      proxy: false,
      baseURL: this.getOptionsBaseURL(options),
      timeout: this.getOptionsTimeout(options),
      headers: this.getOptionsHeaders(options),
    })

    $http.interceptors.request.use(
      config => ({
        ...config,
        requestStartTime: getTime()
      })
    )


    $http.interceptors.response.use(
      res => this.handleHttpResponse(res),
      err => {
        err.config = {
          ...err.config,
          requestEndTime: getTime()
        }

        this.handleHttpErrorResponse(err)
      }
    )

    return $http
  }

  /* ------------------------------------------- */

  getOptionsTimeout(options) {
    const timeout = parseInt(options.timeout, 10)
    if (isNaN(timeout) || timeout <= 0) {
      return 5000
    }
    return timeout
  }

  getOptionsBaseURL(options) {
    if (!options.baseURL) {
      return undefined
    }

    if (isServer()) {
      return options.serverBaseURL
    }

    return options.baseURL
  }

  getOptionsHeaders(options) {
    let optionsHeaders = {
      ...options.headers
    }
    if (options._ip) {
      optionsHeaders['X-Forwarded-For'] = options._ip
    }
    if (options._contentId) {
      optionsHeaders['X-client-fb-content-id'] = options._contentId
    }

    return optionsHeaders
  }
  /* ------------------------------------------- */

  handleHttpResponse(res) {
    return handleAxiosResponse(
      res,
      resData => this.extractResponseError(resData)
    )
  }

  extractResponseError(resData) {
    const { code, message, msg } = resData
    if (code !== 0) {
      return {
        errorMessage: message || msg,
        errorCode: code
      }
    }

    return null
  }

  handleHttpErrorResponse(err) {
    return handleAxiosErrorResponse(err)
  }

  /* ------------------------------------------- */

  useRequestInterceptor(factory) {
    this.$client.interceptors.request.use(factory)
  }

  useResponseInterceptor(onSuccess, onError) {
    this.$client.interceptors.response.use(onSuccess, onError)
  }

  useErrorInterceptor(onError) {
    this.useResponseInterceptor(
      res => res,
      onError
    )
  }

  /* ------------------------------------------- */
  send(args) {
    let payload

    // client/api 走cdn加速
    if (!isServer() && args.url && args.url.startsWith('/client/api/')) {
      payload = {
        ...args,
        baseURL: this._options.baseDynamicURL || this._options.baseURL
      }
    } else {
      payload = args
    }

    if (isServer()) {
      Object.keys(INNER_URL_HOSTNAME_MAP).forEach(key => {
        if (args.url && args.url.startsWith(key)) {
          payload = {
            ...args,
            baseURL: INNER_URL_HOSTNAME_MAP[key]
          }
        } else if (args.url && args.url.indexOf(key) > -1) {
          let url = key + args.url.split(key)[1]
          payload = {
            ...args,
            url,
            baseURL: INNER_URL_HOSTNAME_MAP[key]
          }
        }
      })
    }

    return this.$client.request(payload)
  }
}

export default HttpClient